/**
 * Singari theme.js — shared site JavaScript (ported from base.js).
 * Defensive: header/menu/search work even if GSAP CDN fails.
 */
document.addEventListener('DOMContentLoaded', function () {
  var hasGsap = typeof window.gsap !== 'undefined';
  if (hasGsap && typeof window.ScrollTrigger !== 'undefined') {
    try {
      var plugins = [];
      if (typeof window.ScrollTrigger !== 'undefined') plugins.push(window.ScrollTrigger);
      if (typeof window.ScrollToPlugin !== 'undefined') plugins.push(window.ScrollToPlugin);
      if (plugins.length) window.gsap.registerPlugin.apply(window.gsap, plugins);
    } catch (e) { /* no-op */ }
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mainNav = document.getElementById('mainNav');
  var searchOverlay = document.getElementById('searchOverlay');
  var searchToggle = document.getElementById('searchToggle');
  var searchClose = document.getElementById('searchClose');
  var mobileMenu = document.getElementById('mobileMenu');
  var mobileClose = document.getElementById('mobileClose');
  var navToggle = document.getElementById('navToggle');

  function onScrollHeader() {
    if (!mainNav) return;
    var sy = window.scrollY || window.pageYOffset;
    if (sy > 60) {
      mainNav.classList.add('frosted');
      mainNav.classList.add('scrolled');
    } else {
      mainNav.classList.remove('frosted');
      mainNav.classList.remove('scrolled');
    }
  }
  onScrollHeader();
  window.addEventListener('scroll', onScrollHeader, { passive: true });

  // Predictive-search style overlay toggle (native Shopify search form inside).
  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function () {
      searchOverlay.classList.toggle('open');
      if (searchOverlay.classList.contains('open')) {
        var input = searchOverlay.querySelector('.search-input');
        if (input) input.focus();
      }
    });
  }
  if (searchClose && searchOverlay) {
    searchClose.addEventListener('click', function () {
      searchOverlay.classList.remove('open');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay) searchOverlay.classList.remove('open');
    if (e.key === 'Escape' && mobileMenu) {
      mobileMenu.classList.remove('open');
      if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
    }
  });

  if (navToggle && mobileMenu) {
    navToggle.addEventListener('click', function () {
      mobileMenu.classList.add('open');
      navToggle.setAttribute('aria-expanded', 'true');
    });
  }
  if (mobileClose && mobileMenu) {
    mobileClose.addEventListener('click', function () {
      mobileMenu.classList.remove('open');
      if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
    });
  }
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
      });
    });
    mobileMenu.addEventListener('click', function (e) {
      if (e.target === mobileMenu) {
        mobileMenu.classList.remove('open');
        if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }


  /* ==========================================================
   5. GOOGLE SHEETS MIRROR — log every contact-form submission
   ========================================================== */
 document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var act = f.getAttribute('action') || '';
    if (act.indexOf('/contact') === -1 || !window.SINGARI_SHEETS_URL) return;
    try {
      var fd = new FormData(f);
      fd.append('form', f.getAttribute('id') || 'contact-form');
      fd.append('page', window.location.href);
      var body = new URLSearchParams();
      fd.forEach(function (v, k) { body.append(k, v); });
      fetch(window.SINGARI_SHEETS_URL, { method: 'POST', mode: 'no-cors', keepalive: true, body: body });
    } catch (err) {}
  }, true);







  if (reduceMotion) {
    document.querySelectorAll('.reveal, .reveal-clip').forEach(function (el) {
      el.classList.add('in');
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }
});
